export const apiUrls = {
  groupLoginAs: (baseUrl: string) => {
    return `${baseUrl}/security/api/marketplace/group-login-as`;
  },
  userProfileWizard: () => {
    return `v2/user/profile`;
  },
  registrationWizard: () => {
    return `v2/user/registration`;
  },
};
